import routes from '../config/routes';
import { Products } from '../types';

export const onlyUnique = <T>(data: T[]): T[] => [...new Set(data)];

export const importImages = (modules: Record<string, string>) =>
  Object.entries(modules).map(([key, value]) => ({
    imgPath: value,
    label: key.split('/').pop() ?? key,
  }));

export function batchReduce<T>(arr: T[], batchSize: number): T[][] {
  return arr.reduce((batches, curr, i) => {
    if (i % batchSize === 0) batches.push([]);
    batches[batches.length - 1].push(arr[i]);
    return batches;
  }, [] as T[][]);
}

export const searchParse = (str: string) =>
  str
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const getCategories = (productsData: Products[]) => {
  const categories: string[][] = [];
  productsData?.flat().forEach(i => {
    if (i.tags) categories.push(i.tags.split(','));
  });
  return onlyUnique(categories.flat());
};

export const navigateToExternalLink = (url: string, newWindow = true) => {
  window.open(url, newWindow ? '_blank' : undefined, 'noopener,noreferrer');
};

export type NavLinkItem = { type: 'link'; label: string; to: string; isCta?: boolean };
export type NavDropdownItem = {
  type: 'dropdown';
  label: string;
  options: { label: string; action: () => void }[];
};
export type NavItem = NavLinkItem | NavDropdownItem;

export const getMenuOptions = (): NavItem[] => {
  return [
    { type: 'link', label: 'Inicio', to: routes.homeRoute.path },
    { type: 'link', label: 'Productos', to: routes.publicRoutes.products.path },
    { type: 'link', label: 'Empresa', to: routes.publicRoutes.history.path },
    { type: 'link', label: 'Contacto', to: routes.publicRoutes.contactUs.path },
    {
      type: 'link',
      label: 'Solicitar consulta',
      to: routes.publicRoutes.consult.path,
      isCta: true,
    },
  ];
};
